(function () {
  if (customElements.get('ce-radio-group') !== undefined) {
    return;
  }

  class RadioButtonController {
    constructor(root, parent, position) {
      this.elements = {
        root,
        parent,
      };

      this.position = position;
      this.value = this.elements.root.dataset.value;

      this.handleClick = this.handleClick.bind(this);

      this.init();
    }

    init() {
      this.elements.root.addEventListener('click', this.handleClick);
    }

    destroy() {
      this.elements.root.removeEventListener('click', this.handleClick);
    }

    handleClick() {
      if (this.elements.root.hasAttribute('aria-disabled')) {
        return;
      }

      this.elements.parent.setAttribute('current-child', this.position);
    }

    getId() {
      return this.elements.root.id;
    }

    setAttributeChecked(bool) {
      this.elements.root.setAttribute('aria-checked', bool);
    }
  }

  class RadioGroup extends HTMLParsedElement {
    constructor() {
      super();

      this.queuedAttributeChangedCallbackParams = [];

      this.selectors = {
        radioGroup: '[data-radio-group]',
        radioButton: '[data-radio-button]',
      };

      this.elements = null;
      this.controllers = null;
      this.position = null;

      this.handleKeydown = this.handleKeydown.bind(this);
    }

    get currentChild() {
      return this.getAttribute('current-child');
    }

    set currentChild(value) {
      this.setAttribute('current-child', value);
    }

    static get observedAttributes() {
      return ['current-child'];
    }

    attributeChangedCallback(...params) {
      if (!this.parsed) {
        this.queuedAttributeChangedCallbackParams.push(params);
        return;
      }

      const [name, oldValue, newValue] = params;

      if (oldValue === newValue) {
        return;
      }

      switch (name) {
        case 'current-child':
          if (oldValue !== null) {
            const oldChild = this.controllers.radioButtons[oldValue];
            oldChild.setAttributeChecked(false);
          }

          if (newValue !== null) {
            const newChild = this.controllers.radioButtons[newValue];
            this.elements.radioGroup.setAttribute('aria-activedescendant', newChild.getId());
            newChild.setAttributeChecked(true);

            const event = new CustomEvent('ce-radio-group:change', {
              bubbles: true,
              detail: {
                index: this.position,
                value: newChild.value,
              },
            });
            this.dispatchEvent(event);
          }

          break;
      }
    }

    parsedCallback() {
      this.elements = {
        radioGroup: this.querySelector(this.selectors.radioGroup),
        radioButtons: Array.from(this.querySelectorAll(this.selectors.radioButton)),
      };

      this.controllers = {
        radioButtons: this.elements.radioButtons.map((radioButton, i) => new RadioButtonController(radioButton, this, i)),
      };

      this.position = this.elements.radioGroup.dataset.position;

      this.elements.radioGroup.addEventListener('keydown', this.handleKeydown);

      for (let params of this.queuedAttributeChangedCallbackParams) {
        this.attributeChangedCallback(...params);
      }
    }

    disconnectedCallback() {
      this.elements.radioGroup.removeEventListener('keydown', this.handleKeydown);

      for (let radioButton of this.controllers.radioButtons) {
        radioButton.destroy();
      }
    }

    handleKeydown(event) {
      const currentChild = parseInt(this.currentChild);
      const lastChild = this.controllers.radioButtons.length - 1;
      let willPreventEventDefault = true;

      switch (event.key) {
        case ' ':
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          this.currentChild = currentChild === 0 ? lastChild : currentChild - 1;
          break;
        case 'ArrowRight':
        case 'ArrowDown':
          this.currentChild = currentChild === lastChild ? 0 : currentChild + 1;
          break;
        default:
          willPreventEventDefault = false;
          break;
      }

      if (willPreventEventDefault) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }

  customElements.define('ce-radio-group', RadioGroup);
})();
